import { createReducer, on } from '@ngrx/store';
import { FilterItem } from '@shared/models/filters';
import { REQUEST_FILTERS } from '@modules/inbox/configs/request-filters.config';
import { QUOTE_FILTERS } from '@modules/inbox/configs/quote-filters.config';
import { filterActions } from '../../actions/filters/filters.actions';
import { BOOKING_FILTERS } from '@modules/inbox/configs/booking-filters.config';
import { ENQUIRY_FILTERS } from '@features/enquiries/configs/enquiry-filters.config';
import { CUSTOMER_FILTERS } from '@features/customers/configs/customer-filters.config';

const defaultRequestFilters: FilterItem[] = REQUEST_FILTERS;
const defaultQuoteFilters: FilterItem[] = QUOTE_FILTERS;
const defaultBookingFilters: FilterItem[] = BOOKING_FILTERS;
const defaultEnquiryFilters: FilterItem[] = ENQUIRY_FILTERS;
const defaultCustomerFilters: FilterItem[] = CUSTOMER_FILTERS;

export const filtersFeatureKey = 'filters';

export interface FiltersState {
  request_filters: FilterItem[];
  quote_filters: FilterItem[];
  booking_filters: FilterItem[];
  enquiry_filters: FilterItem[];
  customer_filters: FilterItem[];
}

export const initialState: FiltersState = {
  request_filters: defaultRequestFilters,
  quote_filters: defaultQuoteFilters,
  booking_filters: defaultBookingFilters,
  enquiry_filters: defaultEnquiryFilters,
  customer_filters: defaultCustomerFilters
};

export const filtersReducer = createReducer(
  initialState,
  on(filterActions.setRequestFilters, (state: FiltersState, { request_filters }) => {
    return {
      ...state,
      request_filters: request_filters === state.request_filters ? state.request_filters : request_filters
    };
  }),
  on(filterActions.getRequestFilters, (state: FiltersState, { request_filters }) => {
    return {
      ...state,
      request_filters: request_filters === state.request_filters ? state.request_filters : request_filters
    };
  }),
  on(filterActions.setQuoteFilters, (state: FiltersState, { quote_filters }) => {
    return {
      ...state,
      quote_filters: quote_filters === state.quote_filters ? state.quote_filters : quote_filters
    };
  }),
  on(filterActions.getQuoteFilters, (state: FiltersState, { quote_filters }) => {
    return {
      ...state,
      quote_filters: quote_filters === state.quote_filters ? state.quote_filters : quote_filters
    };
  }),
  on(filterActions.setBookingFilters, (state: FiltersState, { booking_filters }) => {
    return {
      ...state,
      booking_filters: booking_filters === state.booking_filters ? state.booking_filters : booking_filters
    };
  }),
  on(filterActions.getBookingFilters, (state: FiltersState, { booking_filters }) => {
    return {
      ...state,
      booking_filters: booking_filters === state.booking_filters ? state.booking_filters : booking_filters
    };
  }),
  on(filterActions.setEnquiryFilters, (state: FiltersState, { enquiry_filters }) => {
    return {
      ...state,
      enquiry_filters: enquiry_filters === state.enquiry_filters ? state.enquiry_filters : enquiry_filters
    };
  }),
  on(filterActions.getEnquiryFilters, (state: FiltersState, { enquiry_filters }) => {
    return {
      ...state,
      enquiry_filters: enquiry_filters === state.enquiry_filters ? state.enquiry_filters : enquiry_filters
    };
  }),
  on(filterActions.setCustomerFilters, (state: FiltersState, { customer_filters }) => {
    return {
      ...state,
      customer_filters: customer_filters === state.customer_filters ? state.customer_filters : customer_filters
    };
  }),
  on(filterActions.getCustomerFilters, (state: FiltersState, { customer_filters }) => {
    return {
      ...state,
      customer_filters: customer_filters === state.customer_filters ? state.customer_filters : customer_filters
    };
  })
);
